import { FC } from "react";
import { useSectionNavigationContext } from "../section-navigation-context";
import { SectionNavigationHeaderProps } from "./interfaces";

const SectionNavigationHeader: FC<SectionNavigationHeaderProps> = ({
  children,
  className,
  customHTMLTag: Wrapper = "h2",
  ...rest
}) => {
  const { getHeaderProps } = useSectionNavigationContext();

  if (!getHeaderProps) {
    throw new Error(
      "SectionNavigation.Header component requires getHeaderProps to be defined",
    );
  }

  return <Wrapper {...getHeaderProps(rest)}>{children}</Wrapper>;
};

export default SectionNavigationHeader;
